module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('img', {
    staticClass: "img1",
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "chapauthor"
  }, [_c('strong', [_c('em', [_vm._v("By Dr. Joe Vitale")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("A")]), _vm._v("bout 15 years ago I used to study the books of Dr. Robert Anthony. I thought they were works of genius. They had helped me more than anything else I had read or done at that time in my life.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I still regard his book, "), _c('em', [_vm._v("“The Advanced Formula for Total Success”")]), _vm._v(" as a masterpiece, but what really influenced me was a set of tapes called, "), _c('em', [_vm._v("“Beyond Positive Thinking")]), _vm._v(".” They were written and recorded by Dr. Robert Anthony.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I remember listening to them and discussing the concepts in them with friends of mine. We all marveled at what we were learning. This material truly revealed the secrets of the universe, but life went on and I lost track of the books, the tapes and Dr. Robert Anthony. I moved a few times, went through a divorce, wrote books of my own, recorded material of my own and went on my way to create my own success in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I had pretty much forgotten Dr. Robert Anthony, but never forgot what I had learned from him. Studying his work instilled in me the mindset for success that helped me become the person I am today.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Then one day something shocking happened to me. I opened my email and there was a message from someone calling himself Dr. Robert Anthony. I couldn’t believe it. I thought he had died! As it turned out, he was alive and well, and he was living in Australia. He wrote to tell me that he was a great admirer of my best-selling book, “Spiritual Marketing.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("You can imagine how shocked I was to hear all this. The man I had studied 15 years ago is now in my life telling me he loves my books! Not "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("only that, but he wanted to co-author a book with me. Wow! We did just that! We released the eBook, “"), _c('em', [_vm._v("Spiritual Marketing in Action”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("However, that isn’t the juicy part of this story After hearing from Dr. Anthony, co-authoring a book with him, and meeting him, he then proceeded to stun me even further. He told me that his book that I loved so much, "), _c('em', [_vm._v("“The Advanced Formula for Total Success” was")]), _vm._v(" actually based on his famous tape set, "), _c('em', [_vm._v("Beyond Positive Thinking")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("He then told me the book and the tapes were out of print. However, he was working on updating all the material and wanted to republish the book and record the newly updated version of "), _c('em', [_vm._v("“Beyond Positive Thinking")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Then he asked me if I would be interested in recording it. Can you believe it? Life is a series of miracles, so here I am, Joe Vitale, the person who has had the once in a lifetime opportunity to record the best self-help wisdom of all time.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("This is the material that people loved so much that they would buy multiple copies and give them to their family and friends. This is the material that changed my life. This is truly the Holy Grail of self-improvement. I hope you will gain as much from it as I have.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("Dr. Joe Vitale")]), _vm._v(" "), _c('p', {
    staticClass: "normal1a"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.beyondpositivethinking.com",
      "target": "_blank"
    }
  }, [_vm._v("http://www.beyondpositivethinking.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal1a"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.mrfire.com",
      "target": "_blank"
    }
  }, [_vm._v("http://www.mrfire.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-725840fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 69
// module chunks = 0